import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-deepblue-950 text-slate-400 py-8 md:py-12 border-t border-deepblue-900" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-130">
          <div className="text-center md:text-left" data-id="element-131">
            <h3 className="text-xl md:text-2xl font-display font-black text-white mb-1 md:mb-2" data-id="element-132">
              AQUAGYM RESUELTO™
            </h3>
            <p className="text-xs md:text-sm max-w-md" data-id="element-133">
              El sistema de clases N°1 para instructores de aquagym en
              Argentina. Porque enseñar en el agua no debería costarte todas las
              noches de la semana.
            </p>
          </div>

          <div className="flex flex-col gap-2 md:gap-3 text-xs md:text-sm" data-id="element-134">
            <a href="mailto:contacto@recursosfitness.shop" className="flex items-center gap-2 hover:text-aqua-400 transition-colors" data-id="element-135">
              <Mail className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-136" />{' '}
              contacto@recursosfitness.shop
            </a>
            <a href="#" className="flex items-center gap-2 hover:text-aqua-400 transition-colors" data-id="element-137">
              <Instagram className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-138" />{' '}
              @recursosfitness.ar
            </a>
            <a href="#" className="flex items-center gap-2 hover:text-aqua-400 transition-colors" data-id="element-139">
              <Globe className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-140" />{' '}
              recursosfitness.shop
            </a>
          </div>
        </div>

        <div className="border-t border-deepblue-900 pt-4 md:pt-8 text-center text-[10px] md:text-xs text-deepblue-500" data-id="element-141">
          © RecursosFitness™ 2026 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}